import {
  ControllerSectionedMenu,
  ControllerSectionedMenuProps,
} from '@bymason-private/legacy-pattern-components';
import { ControllerNavAction } from '../types';

export default function AccountMenu(
  props: Omit<ControllerSectionedMenuProps<ControllerNavAction>, 'sections'>
) {
  return (
    <ControllerSectionedMenu<ControllerNavAction>
      {...props}
      sections={[
        {
          caption: 'Personal',
          items: [
            {
              id: ControllerNavAction.AccountProfile,
              text: 'Profile',
            },
          ],
        },
        {
          caption: 'Organization',
          items: [
            {
              id: ControllerNavAction.AccountUsers,
              text: 'Users',
            },
            {
              id: ControllerNavAction.AccountApiKeys,
              text: 'API Keys',
            },
            {
              id: ControllerNavAction.AccountNotifications,
              text: 'Notifications',
            },
          ],
        },
      ]}
    />
  );
}
